<template>
  <div class="actHomeData" v-if="pageList.length > 0">
    <div class="content-box">
      <div class="content-title">
        <div class="title-left">
          {{ lan ? showData.advertEnName : showData.advertCnName }}
        </div>
        <div class="title-right" @click="toAll">
          {{ lan ? "MORE" : "查看全部" }}
          <img
            class="youjiantou"
            src="../../assets/youjiantou_grey@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="sub-title-top">
        {{ lan ? showData.advertEnDesc : showData.advertCnDesc }}
      </div>
      <div
        class="content-img-box"
        :class="{
          animated: nowScrollToTop >= 889,
          fadeInUp: nowScrollToTop >= 889,
        }"
      >
        <div
          class="img-show"
          v-for="item in pageList"
          :key="item.id"
          @click="toDetails(item)"
        >
          <img class="store-img-qr" :src="item.showSrc" alt="" />
          <div class="sub-title" v-if="showType != 1">
            {{ lan ? item.exhibitEnTitle : item.exhibitCnTitle }}
          </div>
          <div class="sub-title" v-else>
            {{ lan ? item.activityEnTitle : item.activityCnTitle }}
          </div>
          <div class="home-show-info" v-if="showType != 1">
            {{ lan ? item.exhibitEnSubTitle : item.exhibitCnSubTitle }}
          </div>
          <div class="home-show-info" v-else>
            {{ lan ? item.activityEnSubTitle : item.activityCnSubTitle }}
          </div>
          <div class="home-show-dec" v-if="showType != 1">
            {{ lan ? item.exhibitPlaceEn : item.exhibitPlaceCn }}
          </div>
          <div class="home-show-dec" v-else-if="item.startDate == item.endDate">
            {{ item.startDate }}
          </div>
          <div class="home-show-dec" v-else-if="item.startDate && item.endDate">
            {{ item.startDate }}-{{ item.endDate }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLine" class="grey-line"></div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showLine: {
      type: Boolean,
      default: true,
    },
    showType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lan: this.$store.state.isEn,
      pageList: [],
      id: "",
      nowScrollToTop: 0,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
    showData: {
      handler(newValue, oldValue) {
        this.id = newValue.advertCnDetail;
        this.init(this.id);
      },
      deep: true, // 如果需要监听对象内部值的变化，需要设置 deep 为 true
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    init(id) {
      if (!this.showData || !this.id) return;
      let api = "/exhIbit/list";
      let data = {
        current: 1,
        pageSize: 10,
        id: id || "",
      };
      if (this.showType == 1) {
        api = "/activity/list";
        data = {
          current: 1,
          pageSize: 10,
          id: id || "",
        };
      }
      this.$api.get(api, { ...data }, (r) => {
        const { data, code } = r;
        if (code == 0) {
          if (data && data.length > 0) {
            data.forEach((el, index) => {
              el.showSrc = this.showData.imgList[index].src;
            });
          }
          this.pageList = data.slice(0, 2);
        }
      });
    },
    toAll() {
      if (this.showType) {
        this.$router.push({
          path: "/activityPage/scienceActive",
          query: {
            columnId: 3,
          },
        });
      } else {
        this.$router.push({
          path: "/exhibition/exhibitionPage",
          query: {
            columnId: 2,
          },
        });
      }
    },
    toDetails(item) {
      if (item.link) {
        window.open(item.link, "_blank");
      } else {
        this.$router.push({
          path: "/activityList/activityListInfo",
          query: {
            columnId: 3,
            activityType: item.id,
          },
        });
      }
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.nowScrollToTop = Math.floor(scrollTop);
    },
  },
};
</script>

<style scoped>
.actHomeData {
  position: relative;
}
.actHomeData .content-box {
  width: 90%;
  max-width: 1400px;
  margin: 70px auto;
  background-color: #fff;
}
.content-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ca9d76;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
}
.title-right {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: Regular;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.youjiantou {
  width: 17px;
  height: 20px;
  margin: 2px 0 0 5px;
}
.sub-title {
  max-width: 692px;
  width: 90%;
  font-family: SourceHanSansCN-Bold;
  font-size: 34px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  margin-top: 10px;
}
.grey-line {
  background: #f2f2f2;
  height: 20px;
  width: 100%;
}
.content-img-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.img-show {
  max-width: 680px;
  width: 90%;
  margin-right: 20px;
  cursor: pointer;
}
.img-show:last-child {
  margin-right: 0px;
}

.store-img-qr {
  max-width: 680px;
  width: 100%;
  max-height: 346px;
  height: 90%;
  object-fit: cover;
  cursor: pointer;
}
.home-show-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin: 5px 0;
}
.home-show-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
}
.sub-title-top {
  margin: 7px 0 25px;
  font-size: 26px;
  color: #000000;
  text-align: left;
}
@media (max-width: 1440px) {
  .img-show {
    max-width: 612px;
    width: 100%;
    margin-right: 20px;
    cursor: pointer;
  }
  .img-show:last-child {
    margin-right: 0px;
  }

  .store-img-qr {
    max-width: 612px;
    width: 100%;
    max-height: 306px;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
  .home-show-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 5px 0;
  }
  .sub-title {
    font-size: 28px;
  }
  .sub-title-top {
    font-size: 22px;
    color: #000000;
    text-align: left;
  }
}
@media (max-width: 1200px) {
  .actHomeData {
    max-width: 100%;
    position: relative;
  }
  .content-box {
    width: 100%;
    margin: 40px auto;
    background-color: #ffffff;
  }
  .content-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 30px;
    color: #ca9d76;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
  }
  .sub-title {
    font-size: 22px;
  }
  .title-right {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    text-align: left;
    font-weight: Regular;
    display: flex;
    cursor: pointer;
  }
  .sub-title-top {
    font-size: 20px;
    color: #000000;
    text-align: left;
  }
  .grey-line {
    background: #f2f2f2;
    height: 5px;
    width: 100%;
    margin-top: 70px;
  }
  .content-img-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .img-show {
    max-width: 550px;
    width: 90%;
    margin-right: 20px;
    cursor: pointer;
  }
  .img-show:last-child {
    margin-right: 0px;
  }

  .store-img-qr {
    max-width: 550px;
    width: 100%;
    max-height: 256px;
    height: 90%;
    object-fit: cover;
    cursor: pointer;
  }
  .home-show-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 5px 0;
  }
  .home-show-dec {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
}
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}
</style>